import { useEffect, useState } from "react";
import { Form, Input, Button, Modal, Tabs, message } from 'antd';
import { encode } from 'js-base64';
import { post } from "../../../component/fetch"
import { useLocation  } from "react-router-dom";
import type { TabsProps } from 'antd';
import style from "./index.module.scss"
import store from "../../../reducers"
export const useQuery = () => {
  return new URLSearchParams(useLocation().search);
};
const { Search } = Input;
/**公共登录组件
 * 参数
 * mobile:手机号  默认为空,可传
 * mobileDisabled  手机号是否禁止编辑
 * submit 登录回调
 */
function Login(props: any) {
  const query = useQuery();
  const subjectId = query.get('subjectId') || ''
  const [randomImgUrl, setRandomImgUrl] = useState('')
  const { mobile, mobileDisabled } = props
  const [activeTab, setActiveTab] = useState("1")
  const [registerForm] = Form.useForm()
  // const userInfo:any = store.getState().userInfo
  const items: TabsProps['items'] = [
    {
      key: '1',
      label: `登录`,
    },
    {
      key: '2',
      label: `注册`,
    },
  ];
  /**表单提交事件 */
  const onFinish = (val: any) => {
    let data = { ...val }
    data.mobile = encode(data.mobile)
    data.password = encode(data.password)
    data.subjectId = encode(subjectId)
    post('/user/api/ge/user/login',data,true).then(res=>{
      if(res.code === 0) {
        post('/shop/front/ge/userInfo',{},false).then(result=>{
          store.dispatch({
            type: "SET_USER_INFO",
            ...result.data
          })
          message.success('登录成功')
          props.onCancel()
          props.onOk()
        })

      }else{
        message.error(res.data.msg)
      }
    })
  }
  /**获取图形验证码 */
  function getRandomImgFn() {
    let url = `/user/api/verify/code`;
    fetch(url)
      .then(
        (response) => {
          return response.json();
        },
        (error) => console.log("An error occurred.", error)
      )
      .then((res) => {
        setRandomImgUrl(res.data);
      });
  }
  /** 获取短信验证码事件*/
  const getSmsCode = () => {
    const mobile = registerForm.getFieldValue("mobile")
    if (!mobile) {
      message.info('请填写手机号')
      return
    }
    post(`/user/api/ge/send/online/sms/code`, {
      mobile: encode(mobile),
      smsTitle: "医视界"
    }, true).then(res => {
      message.success('发送成功')
    }).catch(()=>{
      
    })
  }
  const onChange = (key: string) => {
    setActiveTab(key)
  };
  const registerFinish = (val:any) => {
    const {mobile,password,smsCode} = val
      post('/user/api/ge/user/register',{
        mobile:encode(mobile),
        password:encode(password),
        smsCode:encode(smsCode)
      },true).then(res=>{
        if(res.data.code === 0){
          message.success('注册成功')
        }else{
          message.error(res.data.msg)
        }
      })
  }
  useEffect(() => {
    /**初始获取图形验证码 */
    props.open && getRandomImgFn()
  }, [props.open])
  return (<Modal open={props.open} destroyOnClose zIndex={99999} footer={null} onCancel={() => props.onCancel()} width={"400px"}>
    <Tabs defaultActiveKey={activeTab} centered items={items} onChange={onChange}></Tabs >
    {
      activeTab === "1" && <>
        <Form  onFinish={onFinish} initialValues={{ mobile: mobile || "" }}>
          <Form.Item name="mobile" rules={[{ required: true, message: '请输入您的手机号码' }]}>
            <Input placeholder="请输入手机号" disabled={mobileDisabled || false}></Input>
          </Form.Item>
          <Form.Item name="password" rules={[{ required: true, message: '请输入您的密码' }]}>
            <Input type="password" placeholder="请输入密码" autocomplete="new-password"></Input>
          </Form.Item>
          <Form.Item style={{ marginTop: "20px" }}>
            <Button className={style.myBtns} type="primary" htmlType="submit">登录</Button>
          </Form.Item>
          <h3 style={{textAlign:"center"}}>可使用医学电子书包app账号直接登录</h3>
        </Form>
      </>
    }
    {
      activeTab === "2" && <>
        <Form  form={registerForm} onFinish={registerFinish} initialValues={{ mobile: mobile || "" }}>
          <Form.Item name="mobile" rules={[{ required: true, message: '请输入您的手机号码' }]}>
            <Input placeholder="请输入手机号" disabled={mobileDisabled || false}></Input>
          </Form.Item>
          <Form.Item
            name="smsCode"
            rules={[{ required: true, message: '请输入您的短信验证码' }]}
          >
            <Search
              placeholder="请输入短信验证码"
              enterButton={<Button type="primary" style={{ width: '100px', height: '38px' }} onClick={getSmsCode}>获取验证码</Button>}
              style={{ padding: '0' }}
              size="large"
            />
          </Form.Item>
          <Form.Item name="password" rules={[{ required: true, pattern: /^(?=.*[a-z])(?=.*[A-Z])(?=.*?[0-9])[a-zA-Z\d]{8,}$/, message: '不少于8位的字母、数字、大小写组合' }]}>
            <Input type="password" autoComplete="new-password" placeholder="不少于8位的字母、数字、大小写组合"></Input>
          </Form.Item>
          <Form.Item name="confirmPassword" rules={[{ required: true, pattern: /^(?=.*[a-z])(?=.*[A-Z])(?=.*?[0-9])[a-zA-Z\d]{8,}$/, message: '再次确认密码' }]}>
            <Input type="password" autoComplete="new-password" placeholder="再次确认密码"></Input>
          </Form.Item>
          <Form.Item style={{ marginTop: "20px" }}>
            <Button className={style.myBtns} type="primary" htmlType="submit">提交注册</Button>
          </Form.Item>
        </Form>
      </>
    }
  </Modal>)
}
export default Login